import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  'data-id'?: string;
}
export const Icon = ({
  'data-id': dataId,
  ...props
}: IconProps) => <svg viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 flex-shrink-0" {...props} data-id="element-39">
    {/* Solid diagonal line (top-left to bottom-right) */}
    <path d="M2 2L4 2L4 4L2 4Z" fill="#EF3340" data-id="element-40" />
    <path d="M4 4L6 4L6 6L4 6Z" fill="#EF3340" data-id="element-41" />
    <path d="M6 6L8 6L8 8L6 8Z" fill="#EF3340" data-id="element-42" />
    <path d="M8 8L10 8L10 10L8 10Z" fill="#EF3340" data-id="element-43" />
    <path d="M10 10L12 10L12 12L10 12Z" fill="#EF3340" data-id="element-44" />
    <path d="M12 12L14 12L14 14L12 14Z" fill="#EF3340" data-id="element-45" />
    <path d="M14 14L16 14L16 16L14 16Z" fill="#EF3340" data-id="element-46" />
    {/* Dotted diagonal line (top-right to bottom-left) */}
    <circle cx="16" cy="3" r="1" fill="#EF3340" data-id="element-47" />
    <circle cx="14" cy="5" r="1" fill="#EF3340" data-id="element-48" />
    <circle cx="12" cy="7" r="1" fill="#EF3340" data-id="element-49" />
    <circle cx="10" cy="9" r="1" fill="#EF3340" data-id="element-50" />
    <circle cx="8" cy="11" r="1" fill="#EF3340" data-id="element-51" />
    <circle cx="6" cy="13" r="1" fill="#EF3340" data-id="element-52" />
    <circle cx="4" cy="15" r="1" fill="#EF3340" data-id="element-53" />
  </svg>;